export default __webpack_public_path__ + "media/38086a1f3ff62fb385e2944d498d9e54e209e783ac304ff85d23254a66159241.svg";